import { normalizeNamespace } from './client';

/**
 * Tags API service
 */
export class TagsApi {
  constructor(apiClient) {
    this.client = apiClient;
  }

  /**
   * Get all tags for a namespace
   */
  getTags(namespace) {
    const ns = normalizeNamespace(namespace);
    return this.client.get(`/${ns}/tags`);
  }

  /**
   * Create new tag. Creating in the public namespace is moderator-only.
   */
  createTag(tag, namespace) {
    const ns = normalizeNamespace(namespace);
    return this.client.post(`/${ns}/tags`, tag);
  }

  /**
   * Update an existing tag (e.g. rename). Server returns 409 with
   * { conflictTagId } if the new name collides with another tag.
   */
  updateTag(tagId, patch) {
    return this.client.patch(`/private/tags/${tagId}`, patch);
  }

  /**
   * Merge one or more source tags into the target tag. Items are re-tagged
   * to the target and source tags are deleted.
   */
  mergeTags(targetTagId, sourceTagIds) {
    return this.client.patch(
      `/private/tags/${targetTagId}/merge`,
      { tagIds: sourceTagIds },
    );
  }
}

export default TagsApi;
